<template>
  <div class="mb-16">  
   
   <template v-if="article">
    <ContentJournal :article="article" />
  </template>
  <template v-else>
      
    <UiContentwrapper v-if="blog && blog.articles">        
       <UiFullcolumn class="mt-32"> 
         <h1>Sorry, this link has expired</h1>
         <p class="small">The page you are looking for does not exist or has been removed.</p>
         <p class="large">Some topics for you:</p>
        <ul>
          <li v-for="article in blog.articles" :key="article.id">
            <NuxtLink :to="`/blogs/${route.params.blogHandle}/${article.handle}`">{{article.title}}</NuxtLink>
          </li>
        </ul>
       </UiFullcolumn>
    </UiContentwrapper>
    <UiContentwrapper v-else>        
       <UiFullcolumn> 
        <h1>Sorry, this link has expired (404 )</h1>
        <p class="small">The blog you are looking for does not exist or has been removed.</p>
        
       </UiFullcolumn>
    </UiContentwrapper>
    </template>

    
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import { useBlogStore } from '@/stores/blogStore';

const { proxy } = useScriptGoogleTagManager({ id: 'GTM-TXPLJB8M' });
const route = useRoute();
const router = useRouter();
const blogStore = useBlogStore();


// Fetch the blog before rendering the page
const { data: blog, error } = await useAsyncData('blog', async () => {  
  return await blogStore.fetchBlogByHandle(route.params.blogHandle);
});

const handle =  route.params.articleHandle;

const article = computed(() => blogStore.articlesByHandle[handle]);

// Add SEO logic
if (article.value) {
  useArticleSeo(article.value)
}

onMounted(async () => {    
  console.log(`Pushing page_view for ${window.location.href} page to GTM dataLayer`);
  console.log('Page title:', article.value.title || '');
  proxy.dataLayer.push({ 
    event: 'page_view', 
    pageType: 'other pages',
    pageUrl: window.location.href,
    pageTitle: article.value.title || ''
  })

});


</script>



